import { render, staticRenderFns } from "./VueAccordion.vue?vue&type=template&id=f054c476&"
import script from "./VueAccordion.vue?vue&type=script&lang=js&"
export * from "./VueAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports